import common from "@page/common/js/common";
import RenderProductListContent from "@page/productListStatic/js/ProductListContent";
// require('sticky-kit/dist/sticky-kit')
import productListUI from "@page/common/js/productList/productListUI";

const NowMyEquipment = nowEnv.NowMyEquipment;
const NowMyStorage = nowEnv.NowMyStorage;

genquo.productConfig = {
	customFeaturedSlider: true,
	sizeSelectorTypeDesktop: "modelAndItem",
	imageBasePath: "https://image.genquo.tw/",
	zoomboxData: "ModelImage",
	moreJumboImage: ".product-photos__model",
	imageRenderType: "sliceFirst",
	refreshDOMs: [".product-photos__jumbo", ".product-photos__model", ".product-photos__item", ".product-size"],
	imgPath: {
		s: "s",
		l: "",
	},
};
RenderProductListContent();

setTimeout(function () {
	$(".items__image").css("opacity", "1");
}, 100);
